import RealTyper from '@real-typer/react';

const Typer = () => (
  <RealTyper
    cursorBlink
    classes="inline-flex"
    cursorCharacter="│"
    delete={false}
    loop={false}
    strings={['']}
    typeSpeed={1}
  />
);

export default Typer;
